import { createAsyncThunk } from '@reduxjs/toolkit';

import request from '../../modules/Request/request';

export const getTaxonomyList = createAsyncThunk('getTaxonomyList', async (object, { rejectWithValue }) => {
  const response = await request('/taxonomy-list', { method: 'GET' });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getTaxonomyDetails = createAsyncThunk('getTaxonomyDetails', async ({ id }, { rejectWithValue }) => {
  const response = await request('/taxonomy-tree', { method: 'GET', params: id });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const createTaxonomy = createAsyncThunk('createTaxonomy', async (object, { rejectWithValue }) => {
  const response = await request('/taxonomy-create', { method: 'POST', body: object });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const updateTaxonomy = createAsyncThunk('updateTaxonomy', async ({ id, ...rest }, { rejectWithValue }) => {
  const response = await request('/taxonomy-update', { method: 'PUT', params: id, body: rest });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const deleteTaxonomy = createAsyncThunk('deleteTaxonomy', async ({ id }, { rejectWithValue }) => {
  const response = await request('/taxonomy-delete', { method: 'DELETE', params: id });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getTaxonomyReport = createAsyncThunk('getTaxonomyReport', async (object, { rejectWithValue }) => {
  let requestUrl = '/taxonomy-report';

  const {
    search, viewOption, offset, limit, taxonomyId, parentId,
  } = object;

  const query = { view: viewOption, search };

  if (typeof offset === 'number' && typeof limit === 'number') {
    requestUrl = '/taxonomy-feature';
    query.offset = limit * offset;
    query.limit = limit;
  }

  if (taxonomyId) {
    query.taxonomyId = taxonomyId;
  } else if (parentId) {
    query.parentId = parentId;
  }

  const response = await request(requestUrl, { method: 'GET', query });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getTaxonomyExpandedReport = createAsyncThunk('getTaxonomyExpandedReport', async (object, { rejectWithValue }) => {
  const { id, type, viewOption } = object;
  const query = { view: viewOption };
  if (id && (type === 'node' || type === 'feature')) {
    query[`${type}Id`] = id;
  }

  const response = await request('/taxonomy-expanded-report', { method: 'GET', query });
  if (response.success) {
    return response.data;
  }
  const error = response.error && response.error.message
    ? response.error.message
    : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});
